import { ROUTES_CONFIG } from "./routes.config"

export const INSIGHTS_CONFIG = {
    fromPathLabels: {
        [ROUTES_CONFIG.integrationsUrl]: "Integrations",
        [ROUTES_CONFIG.reportsUrl]: "Reports",
    } as Record<string, string>,
}
